import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { FormControl, FormHelperText } from '@material-ui/core';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import ReCAPTCHA from 'react-google-recaptcha';

export interface FormRecaptchaProps {
  label?: string;
  helperText?: string;
}
export const FormRecaptcha = ({
  label,
  name,
  onChange,
  ...props
}: FormRecaptchaProps & FieldHookConfig<string | null> & IFieldProps) => {
  const [field, meta, helpers] = useField<string | null>({ name, ...props });
  const BOOKIT_APP_SITE_KEY = '6LcO4i4UAAAAAP5iOaE1ZUNS_6FjUg0j_FYvZrF-';
  //   const handleChange = e => {
  //     if (onChange !== undefined) {
  //       onChange(e);
  //     }
  //     field.onChange(e);
  //   };
  const recaptchaRef = React.useRef<ReCAPTCHA>(null);
  return (
    <FormControl
      error={meta?.error !== undefined}
      className={props.className}
      fullWidth={true}
      title={'ReCaptcha'}
      variant="outlined"
    >
      <ReCAPTCHA
        // style={{
        //   transform: 'scale(0.77)',
        //   WebkitTransform: 'scale(0.77)',
        //   transformOrigin: '0 0',
        //   WebkitTransformOrigin: '0 0',
        // }}
        ref={recaptchaRef}
        sitekey={BOOKIT_APP_SITE_KEY}
        size="normal"
        badge="inline"
        onChange={value => {
          helpers.setValue(value, true);
        }}
        defaultValue={field.value ?? undefined}
      />

      <FormHelperText>{meta.error}</FormHelperText>
    </FormControl>
  );
};
